import { defaultApi } from "./api";

// POST /web/distributorInquiry
// Payload: distributor inquiry form data
export async function sendDistributorInquiry(payload) {
    const res = await defaultApi.post("/web/distributorInquiry", payload);
    return res.data;
}

// POST /web/sendInquiry
// Payload: { name, email, phone, location, message }
export async function sendHomepageInquiry(payload) {
    const res = await defaultApi.post("/web/sendInquiry", payload);
    return res.data;
}
